import React from 'react'
import { Routes, Route, BrowserRouter } from "react-router-dom";
import ZoomMeeting from './Comps/ZoomMeeting';
import EndMeeting from './Comps/EndMeeting';
const App = () => {
  return (
    <BrowserRouter >
      <Routes>
        <Route path="/" element={<ZoomMeeting />} />
        <Route path="/meetingEnd" element={<EndMeeting />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App